export const deleteTest = (payload?: any) => ({
    type: "@saga/DELETE_TEST",
    payload
});

